'use client';
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import * as React from 'react';
import PropTypes from 'prop-types';
import { ClickAwayListener } from "../ClickAwayListener/index.js";
import { unstable_composeClasses as composeClasses } from "../composeClasses/index.js";
import { getSnackbarUtilityClass } from "./snackbarClasses.js";
import { useSnackbar } from "../useSnackbar/index.js";
import { useSlotProps } from "../utils/index.js";
import { useClassNamesOverride } from "../utils/ClassNameConfigurator.js";
import { jsx as _jsx } from "react/jsx-runtime";
var useUtilityClasses = function() {
    var slots = {
        root: [
            'root'
        ]
    };
    return composeClasses(slots, useClassNamesOverride(getSnackbarUtilityClass));
};
/**
 *
 * Demos:
 *
 * - [Snackbar](https://mui.com/base-ui/react-snackbar/)
 * - [Snackbar](https://mui.com/joy-ui/react-snackbar/)
 * - [Snackbar](https://mui.com/material-ui/react-snackbar/)
 *
 * API:
 *
 * - [Snackbar API](https://mui.com/base-ui/react-snackbar/components-api/#snackbar)
 */ var Snackbar = /*#__PURE__*/ React.forwardRef(function Snackbar(props, forwardedRef) {
    var _props_autoHideDuration = props.autoHideDuration, autoHideDuration = _props_autoHideDuration === void 0 ? null : _props_autoHideDuration, children = props.children, _props_disableWindowBlurListener = props.disableWindowBlurListener, disableWindowBlurListener = _props_disableWindowBlurListener === void 0 ? false : _props_disableWindowBlurListener, _props_exited = props.exited, exited = _props_exited === void 0 ? true : _props_exited, onBlur = props.onBlur, onClose = props.onClose, onFocus = props.onFocus, onMouseEnter = props.onMouseEnter, onMouseLeave = props.onMouseLeave, open = props.open, resumeHideDuration = props.resumeHideDuration, _props_slotProps = props.slotProps, slotProps = _props_slotProps === void 0 ? {} : _props_slotProps, _props_slots = props.slots, slots = _props_slots === void 0 ? {} : _props_slots, other = _object_without_properties(props, [
        "autoHideDuration",
        "children",
        "disableWindowBlurListener",
        "exited",
        "onBlur",
        "onClose",
        "onFocus",
        "onMouseEnter",
        "onMouseLeave",
        "open",
        "resumeHideDuration",
        "slotProps",
        "slots"
    ]);
    var classes = useUtilityClasses();
    var _useSnackbar = useSnackbar(_object_spread_props(_object_spread({}, props), {
        autoHideDuration: autoHideDuration,
        disableWindowBlurListener: disableWindowBlurListener,
        onClose: onClose,
        open: open,
        resumeHideDuration: resumeHideDuration
    })), getRootProps = _useSnackbar.getRootProps, onClickAway = _useSnackbar.onClickAway;
    var ownerState = props;
    var Root = slots.root || 'div';
    var rootProps = useSlotProps({
        elementType: Root,
        getSlotProps: getRootProps,
        externalForwardedProps: other,
        externalSlotProps: slotProps.root,
        additionalProps: {
            ref: forwardedRef
        },
        ownerState: ownerState,
        className: classes.root
    });
    var clickAwayListenerProps = useSlotProps({
        elementType: ClickAwayListener,
        externalSlotProps: slotProps.clickAwayListener,
        additionalProps: {
            onClickAway: onClickAway
        },
        ownerState: ownerState
    });
    // ClickAwayListener doesn't support ownerState
    delete clickAwayListenerProps.ownerState;
    // So that we only render active snackbars.
    if (!open && exited) {
        return null;
    }
    return /*#__PURE__*/ _jsx(ClickAwayListener, _object_spread_props(_object_spread({}, clickAwayListenerProps), {
        children: /*#__PURE__*/ _jsx(Root, _object_spread_props(_object_spread({}, rootProps), {
            children: children
        }))
    }));
});
process.env.NODE_ENV !== "production" ? Snackbar.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * The number of milliseconds to wait before automatically calling the
   * `onClose` function. `onClose` should then set the state of the `open`
   * prop to hide the Snackbar. This behavior is disabled by default with
   * the `null` value.
   * @default null
   */ autoHideDuration: PropTypes.number,
    /**
   * @ignore
   */ children: PropTypes.node,
    /**
   * If `true`, the `autoHideDuration` timer will expire even if the window is not focused.
   * @default false
   */ disableWindowBlurListener: PropTypes.bool,
    /**
   * The prop used to handle exited transition and unmount the component.
   * @default true
   */ exited: PropTypes.bool,
    /**
   * Callback fired when the component requests to be closed.
   * Typically `onClose` is used to set state in the parent component,
   * which is used to control the `Snackbar` `open` prop.
   * The `reason` parameter can optionally be used to control the response to `onClose`,
   * for example ignoring `clickaway`.
   *
   * @param {React.SyntheticEvent<any> | Event} event The event source of the callback.
   * @param {string} reason Can be: `"timeout"` (`autoHideDuration` expired), `"clickaway"`, or `"escapeKeyDown"`.
   */ onClose: PropTypes.func,
    /**
   * If `true`, the component is shown.
   */ open: PropTypes.bool,
    /**
   * The number of milliseconds to wait before dismissing after user interaction.
   * If `autoHideDuration` prop isn't specified, it does nothing.
   * If `autoHideDuration` prop is specified but `resumeHideDuration` isn't,
   * we default to `autoHideDuration / 2` ms.
   */ resumeHideDuration: PropTypes.number,
    /**
   * The props used for each slot inside the Snackbar.
   * @default {}
   */ slotProps: PropTypes.shape({
        clickAwayListener: PropTypes.oneOfType([
            PropTypes.func,
            PropTypes.shape({
                children: PropTypes.element.isRequired,
                disableReactTree: PropTypes.bool,
                mouseEvent: PropTypes.oneOf([
                    'onClick',
                    'onMouseDown',
                    'onMouseUp',
                    'onPointerDown',
                    'onPointerUp',
                    false
                ]),
                onClickAway: PropTypes.func,
                touchEvent: PropTypes.oneOf([
                    'onTouchEnd',
                    'onTouchStart',
                    false
                ])
            })
        ]),
        root: PropTypes.oneOfType([
            PropTypes.func,
            PropTypes.object
        ])
    }),
    /**
   * The components used for each slot inside the Snackbar.
   * Either a string to use a HTML element or a component.
   * @default {}
   */ slots: PropTypes.shape({
        root: PropTypes.elementType
    })
} : void 0;
export { Snackbar };
